import { render, staticRenderFns } from "./select-file.vue?vue&type=template&id=5bf119f9&scoped=true&"
import script from "./select-file.vue?vue&type=script&lang=js&"
export * from "./select-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf119f9",
  null
  
)

export default component.exports